// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__29cJi","title":"Images90_title__2i2Vh","images":"Images90_images__1sF6Z"};